$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  createBurgerIcon();
  customSearchBar();
  updateSponsorTitleTag();
});

// --------------------------------
// Helpers
// Custom burger menu
function createBurgerIcon() {
  $.each(new Array(3), function () {
    $('.header .mobile-nav-toggle').append('<div></div>');
  });
}

// Searchbox scripts
function customSearchBar() {
  let searchPlaceholder = 'Search Website';

  $('.header .searchBox input').val('');
  $('.header .searchBox input').attr('placeholder', searchPlaceholder);
}

// Function to change tag on sponsors
function updateSponsorTitleTag() {
  //sponsors heading replacement
  $(window).load(function () {
    const sponsorsTitle = $('.homepageh1').text();
    $('.homepageh1').replaceWith(`<h2 class="homepageh1">${sponsorsTitle}</h2>`);
  });
}
